export default state => state.vod.legacy.requested;
